import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');
moment.suppressDeprecationWarnings = true;

export const DATETIME_FORMAT = 'DD/MM/YY [às] HH:mm';

export default function momentize(value = '', options = {}) {
  let result;

  try {
    result = moment(value, options.format);
  } catch (err) { /* */ }

  if (result && result.isValid()) {
    if (options.output) {
      return result.format(options.output);
    }

    return result.fromNow();
  }

  return undefined;
}

export function createdAt(value = '') {
  return momentize(value, { output: DATETIME_FORMAT });
}
